export const UserRole = Object.freeze({
  DENTIST: 1,
  CLIENT: 2,
  SMYLOR_BOT: 3,
  PARTICIPANT: 4,
  ADMIN: 5
  });